import { render, staticRenderFns } from "./zjs.vue?vue&type=template&id=2afed31c&scoped=true&"
var script = {}
import style0 from "./zjs.vue?vue&type=style&index=0&id=2afed31c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afed31c",
  null
  
)

export default component.exports